module.exports = __webpack_public_path__ + "static/media/formgeneration.d2d60f59.png";